import { Dispatch } from 'react';
import { AxiosError, AxiosResponse } from 'axios';

// project imports

import {
  createGetHeaderData,
  createHeaderData,
  createQueryParams
} from 'utils/restUtils';
import {
  setCodebooks,
  setEaiContextActions,
  setServiceLevelSpecifications,
  setUserGroups
} from 'features/eai/eaiSlice';

import { apiClient } from 'services/restService';

// types
import { HttpHeaders } from 'models';
import { AppThunk } from 'models/store';
import {
  GetContextActionsRequestBody,
  ResourceContextAction
} from 'models/contextActions';
import { logError } from 'services/Logging';

// ==============================|| EAI THUNKS ||============================== //

export const getEaiCodebooks =
  (): AppThunk => (dispatch: Dispatch<ReturnType<typeof setCodebooks>>) => {
    const headers: HttpHeaders = createGetHeaderData(
      false,
      'application/hal+json'
    );

    apiClient
      .get('/eai/list-of-values', { headers })
      .then((response: AxiosResponse) => {
        const { data } = response;

        dispatch(setCodebooks(data));
      })
      .catch((error: AxiosError) => logError(error));
  };

export const getEaiServiceLevelSpecifications =
  (includeHistory = false): AppThunk =>
  (dispatch: Dispatch<ReturnType<typeof setServiceLevelSpecifications>>) => {
    const headers: HttpHeaders = createGetHeaderData(
      false,
      'application/hal+json'
    );
    const queryParams = createQueryParams({ includeHistory: includeHistory });

    apiClient
      .get(`/eai/service-level-specification${queryParams}`, { headers })
      .then((response: AxiosResponse) => {
        dispatch(setServiceLevelSpecifications(response?.data));
      })
      .catch((error: AxiosError) => logError(error));
  };

export const fetchAndSetEaiContextActions =
  (requestBody: GetContextActionsRequestBody): AppThunk =>
  (dispatch: Dispatch<ReturnType<typeof setEaiContextActions>>) => {
    const headers: HttpHeaders = createHeaderData(true, '*/*');

    apiClient
      .post(`/eai/rule-engine/get-context-action`, requestBody, { headers })
      .then((response: AxiosResponse) => {
        dispatch(
          setEaiContextActions(
            response.data._embedded
              .getContextActionDtoList as ResourceContextAction[]
          )
        );
      })
      .catch((error: AxiosError) => logError(error));
  };

export const getUserGroups =
  (): AppThunk => (dispatch: Dispatch<ReturnType<typeof setUserGroups>>) => {
    const headers: HttpHeaders = createGetHeaderData(
      false,
      'application/hal+json'
    );

    apiClient
      .get('/eai/list-of-values/user-group-names', { headers })
      .then((response: AxiosResponse) => {
        dispatch(setUserGroups(response.data._embedded?.userGroupNameDtoList));
      })
      .catch((error: AxiosError) => logError(error));
  };
